import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var LockFreeLinkedListNodeClass;
function LockFreeLinkedListNode() {
  if (LockFreeLinkedListNodeClass === VOID) {
    class $ {
      constructor() {
        this._next_1 = this;
        this._prev_1 = this;
        this._removed_1 = false;
      }
      addLast_5b0i77_k$(node, permissionsBitmask) {
        var prev = this._prev_1;
        var tmp;
        if (prev instanceof ListClosed()) {
          tmp = ((prev.forbiddenElementsBitmask_1 & permissionsBitmask) === 0 && prev.addLast_5b0i77_k$(node, permissionsBitmask));
        } else {
          node._next_1 = this;
          node._prev_1 = prev;
          prev._next_1 = node;
          this._prev_1 = node;
          tmp = true;
        }
        return tmp;
      }
      close_ari2z4_k$(forbiddenElementsBit) {
        this.addLast_5b0i77_k$(new (ListClosed())(forbiddenElementsBit), forbiddenElementsBit);
      }
      remove_fgfybg_k$() {
        if (this._removed_1)
          return false;
        var prev = this._prev_1;
        var next = this._next_1;
        prev._next_1 = next;
        next._prev_1 = prev;
        this._removed_1 = true;
        return true;
      }
      addOneIfEmpty_2jwoix_k$(node) {
        if (!(this._next_1 === this))
          return false;
        this.addLast_5b0i77_k$(node, -2147483648);
        return true;
      }
    }
    initMetadataForClass($, 'LockFreeLinkedListNode', LockFreeLinkedListNode);
    LockFreeLinkedListNodeClass = $;
  }
  return LockFreeLinkedListNodeClass;
}
var LockFreeLinkedListHeadClass;
function LockFreeLinkedListHead() {
  if (LockFreeLinkedListHeadClass === VOID) {
    class $ extends LockFreeLinkedListNode() {}
    initMetadataForClass($, 'LockFreeLinkedListHead', LockFreeLinkedListHead);
    LockFreeLinkedListHeadClass = $;
  }
  return LockFreeLinkedListHeadClass;
}
var ListClosedClass;
function ListClosed() {
  if (ListClosedClass === VOID) {
    class $ extends LockFreeLinkedListNode() {
      constructor(forbiddenElementsBitmask) {
        super();
        this.forbiddenElementsBitmask_1 = forbiddenElementsBitmask;
      }
    }
    initMetadataForClass($, 'ListClosed');
    ListClosedClass = $;
  }
  return ListClosedClass;
}
//region block: exports
export {
  LockFreeLinkedListHead as LockFreeLinkedListHeaduwhs9comnpmn,
  LockFreeLinkedListNode as LockFreeLinkedListNode18403qmazubk5,
};
//endregion

//# sourceMappingURL=LinkedList.mjs.map
